import React, { Fragment } from "react";
import * as MUI from "@mui/material";
import { ThemeContext } from "../../../../contexts/ThemeContext";
import { Link } from "react-router-dom";
export default function TermsAndConditionsCro() {
  const { mode } = React.useContext(ThemeContext);
  return (
    <Fragment>
      <MUI.Typography variant="h3">Uvjeti korištenja</MUI.Typography>
      <MUI.Divider />
      <Fragment>
        <MUI.Stack spacing={4}>
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h4">
              Politika zaštite podataka
            </MUI.Typography>
            <MUI.Typography variant="h5">
              {String("Uvod").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              Posvećeni smo zaštiti privatnosti i sigurnosti vaših osobnih
              podataka u skladu s Općom uredbom o zaštiti podataka (GDPR) (EU
              Uredba 2016/679). Ova politika objašnjava kako prikupljamo,
              obrađujemo i pohranjujemo vaše osobne podatke prilikom korištenja
              naše platforme za upravljanje veterinarskim klinikama. Naš cilj je
              osigurati transparentnost i povjerenje, uz poštivanje zakona o
              zaštiti podataka, te odgovorno i sigurno rukovati vašim podacima.
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Sigurnosne mjere").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              Koristimo sigurnosne mjere industrijskog standarda kako bismo
              zaštitili vaše podatke, uključujući enkripciju, redovite
              sigurnosne provjere i stroge kontrole pristupa kako bismo
              spriječili neovlašteni pristup.
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("PRISTUP WEB STRANICI").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              Kada otvorite našu Web stranicu, Vaš preglednik će prenijeti
              određene podatke na naš Web poslužitelj. Prijenos podataka se vrši
              iz tehničkih razloga, kako bismo Vam mogli učiniti dostupnima
              zatražene informacije. Kako bi Vam olakšali pristup Web stranici,
              prikupljaju se, pohranjuju na kratko vrijeme i koriste sljedeći
              podaci:
            </MUI.Typography>
            <MUI.List sx={{ listStyleType: "disc" }}>
              <MUI.ListItem sx={{ display: "list-item" }}>
                IP adresa
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list-item" }}>
                Datum i vrijeme pristupa
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list-item" }}>
                Razlika u vremenskoj zoni u odnosu na srednje vrijeme po
                Greenwichu (GMT)
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list" }}>
                Sadržaj zahtjeva (specifična stranica)
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list" }}>
                Status pristupa/HTTP status kod
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list" }}>
                Količina prenesenih podataka
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list" }}>
                Web stranica koja zahtijeva pristup
              </MUI.ListItem>
              <MUI.ListItem sx={{ display: "list" }}>
                Preglednik, postavke jezika, verzija preglednika, operacijskog
                sustava i površine
              </MUI.ListItem>
            </MUI.List>
            <MUI.Typography>
              Nadalje, kako bismo zaštitili naše legitimne interese, takve
              podatke na ograničeno vrijeme pohranjujemo kako bismo mogli
              započeti s praćenjem osobnih podataka u slučaju ili pokušaju
              neovlaštenog pristupa našim poslužiteljima (članak 6(1)(f) Opće
              uredbe o zaštiti podataka).
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Koje podatke prikupljamo").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                Prikupljamo sljedeće vrste podataka kako bismo pružili naše
                usluge:
              </MUI.Typography>
              <MUI.List sx={{ listStyleType: "disc" }}>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Osobni podaci: Ime, broj telefona, adresa e-pošte i ostali
                  kontakt podaci.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Podaci o kućnim ljubimcima: Ime kućnog ljubimca, vrsta,
                  pasmina, dob i zdravstveni podaci (npr. datumi cijepljenja,
                  tretmani).
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Podaci o računu: Korisnička imena, lozinke i postavke povezane
                  s vašim računom.
                </MUI.ListItem>
              </MUI.List>
              <MUI.Typography>
                Ovi podaci omogućuju nam pružanje usluga poput zakazivanja
                termina, upravljanja zdravstvenim kartonima kućnih ljubimaca i
                učinkovite komunikacije između vlasnika ljubimaca i
                veterinarskog osoblja.
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Kako koristimo vaše podatke").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                Vaše podatke obrađujemo u sljedeće svrhe:
              </MUI.Typography>
              <MUI.List sx={{ listStyleType: "disc" }}>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Olakšavanje zakazivanja termina i rezervacija.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Pohrana i upravljanje medicinskim kartonima kućnih ljubimaca
                  za kontinuirano liječenje.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Omogućavanje točne komunikacije između vlasnika kućnih
                  ljubimaca i veterinarskog osoblja.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Podrška za interne alate za upravljanje poslovanjem klinika.
                </MUI.ListItem>
              </MUI.List>
              <MUI.Typography>
                Vaše podatke obrađujemo isključivo radi pružanja i poboljšanja
                naših usluga.
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Tko ima pristup vašim podacima").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                Pristup vašim osobnim podacima ograničen je na ovlašteno
                osoblje:
              </MUI.Typography>
              <MUI.List sx={{ listStyleType: "disc" }}>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Zaposlenici veterinarskih klinika: Zaposlenici klinike koju
                  odaberete za liječenje vašeg kućnog ljubimca. U slučaju
                  promjene klinike, nova klinika ima pristup samo novim
                  podacima, dok prethodna klinika zadržava povijesne podatke o
                  pruženim uslugama.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Administratori aplikacije: Ovlašteni zaposlenici naše tvrtke
                  odgovorni za održavanje i poboljšanje platforme.
                </MUI.ListItem>
              </MUI.List>
              <MUI.Typography>
                Ne dijelimo vaše osobne podatke s trećim stranama osim ako to
                zakon zahtijeva ili ako integriramo vanjske usluge (npr. POS
                sustave) uz vaš pristanak.
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Vaša prava prema GDPR-u").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                Imate sljedeća prava u vezi s vašim podacima:
              </MUI.Typography>
              <MUI.List sx={{ listStyleType: "disc" }}>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Pristup: Pregled svih osobnih podataka koje imamo o vama.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Ispravak: Ispravak netočnih podataka.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Brisanje: Zahtjev za brisanjem vaših podataka, osim zakonski
                  potrebnih zapisa.{" "}
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Prijenos podataka: Zahtjev za kopiju vaših podataka u
                  strukturiranom, strojno čitljivom formatu.
                </MUI.ListItem>
                <MUI.ListItem sx={{ display: "list-item" }}>
                  Povlačenje pristanka: Povlačenje pristanka za obradu podataka
                  u bilo kojem trenutku.
                </MUI.ListItem>
              </MUI.List>
              <MUI.Typography>
                Za ostvarivanje ovih prava kontaktirajte nas na:
                <Link
                  color="inherit"
                  onClick={(e) => {
                    e.preventDefault();
                    window.location.href = `mailto:${"info@kilobyte.hr"}`;
                  }}
                >
                  info@kilobyte.hr
                </Link>
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Razdoblje čuvanja podataka").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                Vaše podatke čuvamo sve dok je vaš račun aktivan. Ako izbrišete
                svoj račun, brišemo sve povezane osobne podatke osim ako je
                zakonski ili operativno potrebno zadržati određene podatke. Na
                primjer, tretmani povezani s vašim kućnim ljubimcem ostaju
                vidljivi klinici koja je pružila uslugu.
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("PRIMJENA KOLAČIĆA").toUpperCase()}
            </MUI.Typography>
            <MUI.Stack spacing={2}>
              <MUI.Typography>
                CENTAR ZA ZAŠTITU NA RADU koristi alate pomoću kojih analizira
                korištenje internetskog portala CENTAR ZA ZAŠTITU NA RADU i
                pomoću kojeg možemo prikupiti određene informacije o vama te
                time stječemo spoznaje o potrebama svojih posjetitelja i/ili
                korisnika kojima je svrha poboljšavanje kvalitete naše ponude. S
                tim u vezi koriste se i tako zvani kolačići, kao i neki drugi
                alati.
              </MUI.Typography>
              <MUI.Typography>
                Korisnik i/ili posjetitelj može putem odgovarajućih postavki na
                svojem računalu, pomoću postavki preglednika kojim se koristite,
                odbiti ili izbrisati kolačiće. Međutim, to može dovesti do toga
                da se neke funkcije internetskog portala CENTAR ZA ZAŠTITU NA
                RADU više ne mogu u potpunosti koristiti.
              </MUI.Typography>
              <MUI.Typography>
                Navedeni alati prikupljaju i pohranjuju neke tehničke podatke,
                uključujući IP adresu korisnika i/ili posjetitelja.
              </MUI.Typography>
            </MUI.Stack>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Usluge trećih strana i globalna uporaba").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              Iako trenutno poslujemo unutar EU, naša platforma temelji se na
              oblaku, a podaci se mogu obrađivati na poslužiteljima u drugim
              zemljama. Osiguravamo da svi međunarodni prijenosi podataka budu u
              skladu s GDPR standardima. Ako integriramo usluge trećih strana
              (npr. POS ili analitiku), osiguravamo da su ti pružatelji usluga
              usklađeni s GDPR-om i da zadovoljavaju naše stroge standarde
              privatnosti.
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("LINKOVI NA DRUGE WEB STRANICE").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              Ova web stranica može sadržavati linkove na druge web stranice
              kojima druga organizacija koja ima svoja posebna pravila
              privatnosti pa skrećemo pažnju da se upoznate s njihovim uvjetima
              korištenja i pravilima privatnosti prije nego im dostavite bilo
              kakve osobne podatke jer CENTAR ZA ZAŠTITU NA RADU ne preuzima
              odgovornost za te web stranice ili organizacije koje njima
              upravljaju.
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Ažuriranja ove politike").toUpperCase()}
            </MUI.Typography>
            <MUI.Typography>
              Ovu politiku možemo povremeno ažurirati kako bismo odražavali
              promjene u zakonskim zahtjevima ili našim uslugama. Značajne
              promjene bit će komunicirane putem e-pošte ili unutar aplikacije
              prije nego što stupe na snagu.
            </MUI.Typography>
          </MUI.Stack>
          <MUI.Divider />
          <MUI.Stack spacing={1}>
            <MUI.Typography variant="h5">
              {String("Kontakt podaci".toUpperCase())}
            </MUI.Typography>
            <MUI.Typography>
              Ako imate pitanja, zabrinutosti ili pritužbe vezane uz ovu
              politiku, možete nas kontaktirati na: Email:{" "}
              <Link
                color="inherit"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href = `mailto:${"info@kilobyte.hr"}`;
                }}
              >
                info@kilobyte.hr
              </Link>
            </MUI.Typography>
          </MUI.Stack>
        </MUI.Stack>
      </Fragment>
    </Fragment>
  );
}
